<template>
  <div class="container college">
    <div class="header card">
      <el-breadcrumb class="breadcrumb"
                     separator="/">
        <el-breadcrumb-item>资源管理</el-breadcrumb-item>
        <el-breadcrumb-item>试卷管理</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <h2 class="title">试卷管理</h2>
        </div>
        <div class="right">
          <el-button class="button"
                     type="primary"
                     @click="handlePaperCreate">创建试卷</el-button>
        </div>
      </div>
    </div>
    <div class="filters card">
      <el-form class="search-wrap"
               ref="searchForm"
               :inline="true"
               :model="query">
        <el-form-item label="试卷名称"
                      prop="keyword">
          <el-input v-model="query.keyword"
                    placeholder="输入试卷名称/ID"
                    @input="fetchPaperList()"></el-input>
        </el-form-item>
        <el-form-item label="试卷名称"
                      prop="keyword">
          <el-input v-model="query.keyword"
                    placeholder="输入试卷名称/ID"
                    @input="fetchPaperList()"></el-input>
        </el-form-item>
        <el-form-item label="题库名称"
                      prop="product_keyword">
          <el-input v-model="query.product_keyword"
                    placeholder="输入题库名称"
                    @input="fetchPaperList()"></el-input>
        </el-form-item>
        <el-form-item label="关联章节"
                      prop="chapter_1_keyword">
          <el-input v-model="query.chapter_1_keyword"
                    placeholder="输入关联章节名称"
                    @input="fetchPaperList()"></el-input>
        </el-form-item>
        <el-form-item label="关联题库院校/专业/科目"
                      prop="product_cms_keyword">
          <el-input v-model="query.product_cms_keyword"
                    placeholder="输入关联题库院校/专业/科目名称或代码"
                    @input="fetchPaperList()"></el-input>
        </el-form-item>

        <el-form-item label="院校/专业/科目">
          <el-input v-model="query.college_major_subject_keyword"
                    placeholder="输入院校/专业/科目名称或代码"
                    clearable
                    @input="fetchPaperList()"></el-input>
        </el-form-item>
        <el-form-item label="状态"
                      prop="status">
          <el-select v-model="query.status"
                     placeholder="请选择"
                     @change="fetchPaperList()">
            <el-option v-for="item in filter.status"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div class="results card">
      <div class="values-header">
        <p class="title">查找结果</p>
      </div>
      <div class="values">
        <el-table class="table"
                  :data="results"
                  border
                  style="width: 100%"
                  @selection-change="handleSelectionChange">
          <el-table-column type="selection"
                           width="50"
                           fixed="left"
                           align="center">
          </el-table-column>
          <el-table-column prop="id"
                           label="ID"
                           width="80"
                           align="center">
          </el-table-column>
          <el-table-column prop="name"
                           label="试卷名称"
                           min-width="300"
                           align="center">
          </el-table-column>
          <el-table-column prop="product_name"
                           label="题库名称"
                           min-width="300"
                           align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.arr_chapter_info.map(item => item.product_name).join('、') }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="chapter_name_1"
                           label="关联章节名称"
                           min-width="300"
                           align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.arr_chapter_info.map(item => item.chapter_name_1).join('、') }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="difficulty"
                           label="难度系数"
                           min-width="120"
                           align="center">
          </el-table-column>
          <el-table-column prop="score"
                           label="分值"
                           min-width="120"
                           align="center">
          </el-table-column>
          <el-table-column prop="item_count"
                           label="题目数量"
                           min-width="120"
                           align="center">
          </el-table-column>
          <el-table-column prop="ref_count"
                           label="被引用次数"
                           min-width="120"
                           align="center">
          </el-table-column>
          <el-table-column label="年份"
                           min-width="120"
                           align="center">
            <template slot-scope="scope">
              {{scope.row.year?`${scope.row.year}年`:""}}
            </template>
          </el-table-column>
          <el-table-column label="科目"
                           show-overflow-tooltip
                           min-width="200"
                           align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.subjects.length">
                {{scope.row.subjects.map(v=>{ return v.name }).join(',')}}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="专业"
                           min-width="200"
                           show-overflow-tooltip
                           align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.majors.length">
                {{scope.row.majors.map(v=>{ return `(${v.code})${v.name}` }).join(',')}}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="院校"
                           min-width="200"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.colleges.length">
                {{scope.row.colleges.map(v=>{ return v.name }).join(',')}}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="状态"
                           width="120"
                           align="center">
            <template slot-scope="scope">
              <el-tag :type="scope.row.status == 1?'success':'danger'">{{scope.row.status == 1 ? '正常' : '下线'}}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="创建时间"
                           width="160"
                           align="center">
            <template slot-scope="scope">
              <span>{{$moment(scope.row.create_time).format('YYYY-MM-DD HH:mm')}}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作"
                           width="200"
                           align="center"
                           fixed="right"
                           v-if="isfixed">
            <template slot-scope="scope">
              <el-button size="mini"
                         type="text"
                         @click="handleToPaperEdit(scope.row, scope.$index)">编辑</el-button>
              <el-button size="mini"
                         type="text"
                         @click="handleToItemsEdit(scope.row, scope.$index)">题目管理</el-button>
              <el-button size="mini"
                         type="text"
                         @click="handleToPaperScoreEdit(scope.row, scope.$index)">分值管理</el-button>
            </template>
          </el-table-column>
          <el-table-column label=""
                           width="40"
                           align="center"
                           fixed="right"
                           v-else>
            <template slot-scope="scope">
              <el-dropdown trigger="click">
                <span class="el-dropdown-link">
                  ...
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="a"
                                    style="margin-bottom:6px;"><span @click="handleToPaperEdit(scope.row, scope.$index)"
                          style="font-size:16px;color: #409EFF;">
                      编辑
                    </span></el-dropdown-item>
                  <el-dropdown-item command="b"
                                    style="margin-bottom:6px;"><span @click="handleToItemsEdit(scope.row, scope.$index)"
                          style="font-size:16px;color: #409EFF;">
                      题目管理
                    </span></el-dropdown-item>
                  <el-dropdown-item command="c"
                                    style="margin-bottom:6px;"><span @click="handleToPaperScoreEdit(scope.row, scope.$index)"
                          style="font-size:16px;color: #409EFF;">
                      分值管理
                    </span></el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer">
        <el-button type="primary"
                   size="small"
                   @click="handleToEditList()">批量修改</el-button>
        <el-pagination background
                       layout="total, prev, pager, next, sizes, jumper"
                       :current-page="Number(query.pageIndex)"
                       :page-sizes="[10, 20, 50, 100, 500]"
                       :page-size="Number(query.pageSize)"
                       :total="Number(pageTotal)"
                       @size-change="handleSizeChange"
                       @current-change="handlePageChange"></el-pagination>
      </div>
    </div>
    <PaperCreate :visible="createDialog"
                 @close="createDialog = false"
                 @submit="fetchPaperList"></PaperCreate>
    <PaperEdit :visible="editDialog"
               :content="editRow"
               @close="editDialog = false"
               @submit="fetchPaperList"></PaperEdit>
    <Score :visible="scoreDialogVisible"
           :paperId="editRow.id"
           @close="scoreDialogVisible=false"></Score>
    <ExamPaperListEdit :visible="editlistDialog"
                       :list="chooseList"
                       @close="editlistDialog=false"
                       @submit="fetchPaperList"></ExamPaperListEdit>
  </div>
</template>

<script>
import PaperCreate from '@/components/dialog/paper/PaperCreate'
import PaperEdit from '@/components/dialog/paper/PaperEdit'
import ExamPaperListEdit from '@/components/dialog/paper/ExamPaperListEdit'
import { examPaperList, exampaperlistUpdate } from '@/api/exam'
import Score from '@/components/dialog/Score'

export default {
  components: {
    PaperCreate,
    PaperEdit,
    Score,
    ExamPaperListEdit,
  },
  data() {
    return {
      scoreDialogVisible: false,
      createDialog: false,
      editDialog: false,
      editRow: {},
      query: {
        keyword: '',
        status: '',
        province_code: '',
        pageIndex: 1,
        pageSize: localStorage.getItem('pageSize')
          ? Number(localStorage.getItem('pageSize'))
          : 10,
        isPaging: 1,
        product_keyword: '',
        chapter_1_keyword: '',
        product_cms_keyword: '',
      },
      pageTotal: 10,
      filter: {
        status: [
          { label: '全部', value: '' },
          { label: '正常', value: '1' },
          { label: '下线', value: '0' },
        ],
      },
      results: [],
      isfixed: document.body.clientWidth < 820 ? false : true,
      chooseList: [],
      editlistDialog: false,
    }
  },
  created() {
    this.parseQuery()
    this.fetchPaperList()
  },
  methods: {
    // 试卷列表请求
    fetchPaperList() {
      examPaperList(this.query).then((res) => {
        this.results = res.list || []
        this.pageTotal = res.count
      })
      this.syncQuery()
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, 'pageSize', val)
      localStorage.setItem('pageSize', val)
      this.fetchPaperList()
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, 'pageIndex', val)
      this.fetchPaperList()
    },
    // 触发搜索按钮
    handleSearch() {
      this.$set(this.query, 'pageIndex', 1)
      this.fetchPaperList()
    },
    // 重置搜索条件
    handleFormReset(formName) {
      this.$refs[formName].resetFields()
      this.fetchPaperList()
    },
    // 部分内容渲染
    handleRender(value, type) {
      let status = {
        1: '正常',
        2: '关闭',
      }
      if (type == 'status') {
        return status[value] || ''
      }
      return ''
    },
    // 试卷创建
    handlePaperCreate() {
      this.createDialog = true
    },
    // 试卷编辑
    handleToPaperEdit(row) {
      this.editRow = Object.assign({}, row, {
        status: row.status == 1 ? true : false,
      })
      this.editDialog = true
    },
    // 分值管理
    handleToPaperScoreEdit(row) {
      this.editRow = Object.assign({}, row, {
        status: row.status == 1 ? true : false,
      })
      this.scoreDialogVisible = true
    },
    // 试卷题目编辑
    handleToItemsEdit(row) {
      this.$router.push(`/resource/paper/${row.id}`)
    },
    // 解析URL请求参数
    parseQuery() {
      Object.keys(this.$route.query).forEach((key) => {
        this.query[key] = this.$route.query[key]
      })
    },
    // 同步URL请求参数
    syncQuery() {
      let isSync = Object.keys(this.query).some(
        (key) => this.$route.query[key] != this.query[key]
      )
      isSync &&
        this.$router.replace({
          query: Object.assign({}, this.$route.query, this.query),
        })
    },
    handleSelectionChange(val) {
      this.chooseList = val
    },
    handleToEditList() {
      if (this.chooseList.length == 0) {
        this.$message.error('还没有选择要修改的数据')
        return
      }
      this.editlistDialog = true
    },
  },
}
</script>

<style scoped lang="less">
.college {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        // font-size: 14px;
        // padding: 12px 20px;
      }
    }
  }

  .filters {
    margin-top: 10px;

    .search-wrap {
      margin-bottom: -18px;

      .datetime {
        width: 380px;
      }
    }
    .divider {
      border-bottom: 1px dashed #dcdfe6;
      margin: 15px 0;
    }
    .action-wrap {
      display: flex;
      justify-content: flex-end;
    }
  }
  .results {
    flex: 1;
    margin-top: 10px;

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .values {
    }
    .avatar {
      display: block;
      width: 68px;
      height: 68px;
      object-fit: cover;
      margin: 0 auto;
    }
    .footer {
      display: flex;
      justify-content: space-between;
      margin-top: 20px;
    }
  }
  .el-dropdown-link {
    cursor: pointer;
    color: #409eff;
  }
}
</style>
